import React from 'react'
import { CompanyFilesProvider } from './context/CompanyFilesProvider'
import { CompanyFilesMain } from './components/CompanyFilesMain'

export const CompanyFiles = () => (
  <CompanyFilesProvider>
    <CompanyFilesMain />
  </CompanyFilesProvider>
)
